import { intersection, compact, isEmpty } from 'lodash';
import { transformSizeGroupModelsToFilterGroupModels } from 'data/transformers/size-group';
export const catalogsInAscOrder = (catalog, other) => catalog.order - other.order;
export const catalogModelToCatalogListItem = catalog => {
  const {
    id,
    title,
    catalogIds,
    parentId,
    code,
    depth,
    photo
  } = catalog;
  return {
    id,
    title,
    value: id,
    data: {
      id,
      catalogIds,
      parentId,
      code,
      depth,
      photo
    }
  };
};
export const catalogModelsToCatalogListItems = catalogs => catalogs.map(catalogModelToCatalogListItem);
export const getNewPriceRange = (priceFrom, priceTo) => {
  if (priceFrom && priceTo && parseFloat(priceFrom) > parseFloat(priceTo)) {
    return {
      priceFrom: priceTo,
      priceTo: null
    };
  }

  return {
    priceTo,
    priceFrom
  };
};
export const getMatchingSizeFilterGroupModels = _ref => {
  let {
    selectedCatalogCode,
    sizeCategories,
    sizeGroups,
    selectedCatalogs
  } = _ref;
  if (!selectedCatalogCode) return [];
  const sizeCategory = sizeCategories.find(it => it.code === selectedCatalogCode);
  if (!sizeCategory) return [];

  const catalogsToSizeGroupIds = catalog => catalog.sizeGroupId === null ? catalog.sizeGroupIds : [...catalog.sizeGroupIds, catalog.sizeGroupId];

  const catalogSizeGroupIds = selectedCatalogs.flatMap(catalogsToSizeGroupIds);
  const availableSizeGroupIds = isEmpty(selectedCatalogs) ? sizeCategory.size_groups : intersection(sizeCategory.size_groups, catalogSizeGroupIds);
  const sizeGroupModels = compact(availableSizeGroupIds.map(id => sizeGroups.find(it => it.id === id)));
  return transformSizeGroupModelsToFilterGroupModels(sizeGroupModels);
};
export const getMatchingSizeCategories = (sizeCategories, selectedCatalogs) => {
  if (isEmpty(selectedCatalogs)) return sizeCategories;

  const catalogsToSizeGroupIds = catalog => catalog.sizeGroupId === null ? catalog.sizeGroupIds : [...catalog.sizeGroupIds, catalog.sizeGroupId];

  const availableSizeGroupIds = selectedCatalogs.flatMap(catalogsToSizeGroupIds);

  const filter = category => !isEmpty(intersection(availableSizeGroupIds, category.size_groups));

  return sizeCategories.filter(filter);
};